import { Component } from '@angular/core';
import { Event, Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, GuardsCheckEnd } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PlatformLocation } from '@angular/common';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  currentUrl: string;
  constructor(
    public _router: Router,
    location: PlatformLocation,
    private spinner: NgxSpinnerService
  ) {
    this._router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf('/') + 1
        );
      }
      // Route guards may open a dialog (a CanDeactivate guard asks before leaving
      // unsaved report edits), and lazy-chunk loading happens BEFORE guards run,
      // so the spinner is shown only once the guards have allowed the navigation.
      // It is hidden on every terminal outcome, not just success, or a cancelled
      // navigation would leave the page covered.
      if (routerEvent instanceof GuardsCheckEnd) {
        if (routerEvent.shouldActivate) {
          this.spinner.show();
        } else {
          this.spinner.hide();
        }
      }
      if (routerEvent instanceof NavigationEnd) {
        this.spinner.hide();
        window.scrollTo(0, 0);
      }
      if (routerEvent instanceof NavigationCancel || routerEvent instanceof NavigationError) {
        this.spinner.hide();
      }
    });
  }
}
